import moment, { Moment } from 'moment';
import React, { FC } from 'react';
import { DatePicker } from 'components/atoms/date-picker';
import { API_DATE_FORMAT } from 'components/atoms/due-date-picker';
import { disabledDueDate } from 'utils/date-field/disabled-dates';
import { ProjectDefaultFieldProps } from './type';

export const DueDateField: FC<ProjectDefaultFieldProps> = ({
  isReadOnly,
  projectData,
  onDefaultFieldChange,
}) => {
  return (
    <DatePicker
      value={projectData.dueDate ? moment(projectData.dueDate) : undefined}
      allowClear={false}
      disabled={isReadOnly}
      onChange={(resp) => {
        onDefaultFieldChange({
          dueDate: moment(resp).format(API_DATE_FORMAT),
        });
      }}
      disabledDate={(current: Moment) =>
        disabledDueDate(
          current,
          projectData.startDate ? moment(projectData.startDate) : undefined,
        )
      }
    />
  );
};
